/**
 * Cda related apis
 */

import { 
  getRequestConfig, 
  getFileUploadRequestConfig,
  getFileDownloadRequestConfig
} from './config';
import { 
  CDA_UPLOAD_ACTION, 
  SCAN_CDA_ACTION,
  REQUEST_CDA_ACTION, 
  SAVE_CDA_ACTION,
  DOWNLOAD_CDA_ACTION,
  DELETE_CDA_ACTION
} from './ajaxActions';
import { 
  GET_CDA_DOC_SUCCESS_MESSAGE, 
  UPLOAD_CDA_SUCCESS_MESSAGE, 
  SAVE_CDA_SUCCESS_MESSAGE,
  CDA_EXISTS_MESSAGE,
  INVALID_FILE_FORMAT_MESSAGE
} from './ajaxActionResponse';
import { request } from './request';

/**
 * Uploads cda to database
 * upload success reponse from server: {'message' : 'cdaUploadedMessage', 'id' : $idCda}
 * @param {object} formData multipart form data, contains cda in xml format
 * @returns promise
 */
export function uploadCda (formData) {
  const config = getFileUploadRequestConfig(formData, CDA_UPLOAD_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === UPLOAD_CDA_SUCCESS_MESSAGE) {
        resolve(response);
      } else if (response && response.data.message === CDA_EXISTS_MESSAGE) {
        reject('CDA is already uploaded.');
      } else if (response && response.data.message === INVALID_FILE_FORMAT_MESSAGE) {
        reject('Invalid CDA file format.');
      } else {
        reject(`unable to upload cda: ${(response?response.data:'no reponse from server')}`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });
};

export function scanCdaById(id) {
  const config = getRequestConfig({id: id}, SCAN_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === 'cdaScanedMessage') {
        resolve();
      } else {
        reject(`Failed to scan cda..`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });

}

/**
 * Retrieves cda as a document for viewing
 * request success reponse from server: {'message' : 'replyCdaMessage', 'id' : $idCda, 'text': $cdaDoc}
 * @param {integer} id id of cda to request
 * @returns promise
 */
export function getCdaDocById(id) {
  // const config = getRequestConfig({id: id}, REQUEST_CDA_ACTION);
  const config = getRequestConfig({id: id}, REQUEST_CDA_ACTION, '/file/cdas');

  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response.data.data.cda);
    })
    .catch( (err) => {
      reject(err);
    });
  });
};

export function requestSaveCda(id) {
  const config = getRequestConfig({id: id}, SAVE_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      if (response && response.data.message === SAVE_CDA_SUCCESS_MESSAGE) {
        resolve(response);
      } else {
        reject(`unable to save cda ${id}, response: ${JSON.stringify(response)}`);
      }
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function downloadCdaById(id) {
  const config = getFileDownloadRequestConfig({id: id}, DOWNLOAD_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then( (response) => {
      resolve(response);
    })
    .catch( (err) => {
      reject(err);
    });
  });
}

export function deleteCdaById(id) {
  const config = getRequestConfig({id:id}, DELETE_CDA_ACTION);
  return new Promise((resolve, reject) => {
    request(config)
    .then((response) => {
      resolve(response);
    })
    .catch((err) => {
      reject(err);
    });
  })
}